import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-2 section-app" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mx-n2" }
const _hoisted_4 = { class: "col-lg-6 px-2" }
const _hoisted_5 = { class: "col-lg-6 px-2" }
const _hoisted_6 = { class: "row mx-n2" }
const _hoisted_7 = { class: "col-lg-12 px-2" }
const _hoisted_8 = { class: "row mx-n2 mt-3" }
const _hoisted_9 = { class: "col-lg-12 px-2" }
const _hoisted_10 = { class: "row mx-n2 mt-3" }
const _hoisted_11 = { class: "col-lg-12 px-2" }
const _hoisted_12 = { class: "row mx-n2 mt-3" }
const _hoisted_13 = { class: "col-lg-12 px-2" }
const _hoisted_14 = { class: "card h-100" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-accent text-white font-weight-bold" }, " Input Uang Riil ", -1)
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "number",
    class: "form-control",
    autocomplete: "off",
    placeholder: "Nominal uang riil"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_RecapSalesMenu = _resolveComponent("RecapSalesMenu")!
  const _component_RecapCancelledMenu = _resolveComponent("RecapCancelledMenu")!
  const _component_RecapMoneyTips = _resolveComponent("RecapMoneyTips")!
  const _component_RecapFreeReturn = _resolveComponent("RecapFreeReturn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Nav),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_RecapSalesMenu)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_RecapCancelledMenu)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_RecapMoneyTips)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_RecapFreeReturn)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changeShift && _ctx.changeShift(...args)), ["prevent"]))
                    }, "Ganti Shift")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}